export default {
  props: {
    body: "turnaround for truck accessories",
    metric: "48hr"
  }
}
